$(document).ready(function(){
  
  $('animate-element.radmorecustom').on('click', function(){
  
    $('#collectionDescriptionDrawer')
      .removeClass('hidden')
      .addClass('active open');
  });
});
$(document).ready(function () {
   
// own dlievry
$('div#delivery-info span#delivery-speed').on('click', function () {
  $('div#delivery-info div#shipping-options').toggle();
  $('div#delivery-info div#shipping-options').toggleClass('active');
  
  $('div#postcode-check').toggle();

  // Toggle icons
  $('svg#question-mark-icon').toggle();
  $('svg#close-icon').toggle();
});

$('#postcode').on('input', function () {
  var currentText = $(this).val();
  console.log("Current postcode input:", currentText);

  // Show loading bar inside shipping-options
  $('.loading-bar').show();
  $('.shipping-table').hide();

  // Hide loading bar after a short delay
  setTimeout(function () {
    $('.loading-bar').hide();
    $('.shipping-table').show();
  }, 300);
});

$('button#close-postcode-check').on('click', function () {
  // Hide elements
  $('div#delivery-info div#shipping-options').hide();
  $('div#postcode-check').hide();

  // Remove the active class
  $('div#delivery-info div#shipping-options').removeClass('active');

  // Reset icons
  $('svg#question-mark-icon').show();
  $('svg#close-icon').hide();
});

});



// delivery
document.addEventListener('DOMContentLoaded', async function() {
    // Check if Day.js is loaded
    if (typeof dayjs === 'undefined') {
        console.error('Day.js is not loaded');
        return;
    }

    // Wait for holidays data to be available in localStorage
    async function waitForHolidaysData() {
        let holidaysCache = JSON.parse(localStorage.getItem('holidaysCache'));
        while (!holidaysCache) {
            console.log('Waiting for holidays data...');
            await new Promise(resolve => setTimeout(resolve, 100));
            holidaysCache = JSON.parse(localStorage.getItem('holidaysCache'));
        }
        return holidaysCache;
    }

    // Initialize the script once holidays data is available
    async function initialize() {
        const holidaysCache = await waitForHolidaysData();
        console.log('Loaded holidays data from localStorage:', holidaysCache);

        const bankHolidays = holidaysCache.bankHolidays.map(date => dayjs(date));
        const carrierHolidays = holidaysCache.carrierHolidays.map(date => dayjs(date));

        // DOM Elements
        const deliverySpeedElement = document.getElementById('delivery-speed');
        const shippingOptionsElement = document.getElementById('shipping-options');
        const postcodeCheckElement = document.getElementById('postcode-check');
        const postcodeInput = document.getElementById('postcode');
        const deliveryDateElement = document.getElementById('delivery-date');
        const questionMarkIcon = document.getElementById('question-mark-icon');
        const closeIcon = document.getElementById('close-icon');
        const closePostcodeCheckButton = document.getElementById('close-postcode-check');

        // Product weight from the context
        const productWeight = 170;
        console.log("Product Weight: ", productWeight);

        // Validate that all required elements are present
        if (!deliverySpeedElement || !shippingOptionsElement || !postcodeCheckElement || !postcodeInput || !deliveryDateElement || !questionMarkIcon || !closeIcon || !closePostcodeCheckButton) {
            console.error("One or more DOM elements not found");
            return;
        }

        // Shipping options data
        const shippingOptions = {
            mainlandUK: {
                under30: [
                    { name: 'Express', time: '1-2 Days', price: '£9.95' },
                    { name: 'Standard', time: '2-3 Days', price: 'FREE' },
                    /*{ name: 'Economy', time: '5-7 Days', price: 'FREE' },*/
                    { name: 'Saturday', time: 'Saturday', price: '£19.95' },
                ],
                over30: [
                    { name: 'Standard Pallet', time: '3-5 Days', price: 'FREE' },
                   /* { name: 'Economy Pallet', time: '5-7 Days', price: 'FREE' },*/
                    { name: 'Express Pallet', time: '1-2 Days', price: '£19.95' },
                ]
            },
            region1: {
                under30: [
                    { name: 'Economy', time: '5-7 Days', price: '£9.95' },
                    { name: 'Express', time: '2-3 Days', price: '£29.95' },
                ],
                over30: [
                    { name: 'Economy Pallet', time: '5-7 Days', price: '£59.00' },
                    { name: 'Express Pallet', time: '2-3 Days', price: '£99.00' },
                ]
            },
            region2: {
                under30: [
                    { name: 'Economy', time: '5-7 Days', price: '£19.95' },
                    { name: 'Express', time: '2-3 Days', price: '£39.95' },
                ],
                over30: [
                    { name: 'Economy Pallet', time: '5-7 Days', price: '£79.00' },
                    { name: 'Express Pallet', time: '2-3 Days', price: '£129.00' },
                ]
            },
            region3: {
                under30: [
                    { name: 'Economy', time: '5-7 Days', price: '£29.95' },
                    { name: 'Express', time: '2-3 Days', price: '£49.95' },
                ],
                over30: [
                    { name: 'Economy Pallet', time: '5-7 Days', price: '£89.95' },
                    { name: 'Express Pallet', time: '2-3 Days', price: '£169.95' },
                ]
            }
        };

        // Postcode region mappings
        const mainlandUKPrefixes = [
            "AL", "B", "BA", "BB", "BD", "BH", "BL", "BN", "BR", "BS", "CA", "CB", "CF", "CH", "CM", "CO", "CR", "CT", "CV", "CW", "DA", "DD", "DE", "DG", "DH", "DL", "DN", "DT", "DY", "E", "EC", "EH", "EN", "EX", "FY", "G", "GL", "GU", "HA", "HD", "HG", "HP", "HR", "HU", "HX", "IG", "IP", "KT", "L", "LA", "LD", "LE", "LL", "LN", "LS", "LU", "M", "ME", "MK", "ML", "N", "NE", "NG", "NN", "NP", "NR", "NW", "OL", "OX", "PE", "PL", "PO", "PR", "RG", "RH", "RM", "S", "SA", "SE", "SG", "SK", "SL", "SM", "SN", "SO", "SP", "SR", "SS", "ST", "SW", "SY", "TA", "TF", "TN", "TQ", "TR", "TS", "TW", "UB", "W", "WA", "WC", "WD", "WF", "WN", "WR", "WS", "WV", "YO"
        ];

        const region1Prefixes = [
            "AB", "BT", "DD", "IV1", "IV2", "IV3", "IV4", "IV5", "IV6", "IV7", "IV8", "IV9", "IV10", "IV11", "IV12", "IV13", "IV14", "IV15", "IV16", "IV17", "IV18", "IV19", "IV30", "IV31", "IV32", "IV33", "IV34", "IV35", "IV36", "PH1", "PH2", "PH3", "PH4", "PH5", "PH6", "PH7", "PH8", "PH9", "PH10", "PH11", "PH12", "PH13", "PH14", "PO30", "PO31", "PO32", "PO33", "PO34", "PO35", "PO36", "PO37", "PO38", "PO39", "PO40", "PO41"
        ];

        const region2Prefixes = [
            "HS", "IV20", "IV21", "IV22", "IV23", "IV24", "IV25", "IV26", "IV27", "IV28", "IV29", "IV37", "IV38", "IV39", "IV40", "IV41", "IV42", "IV43", "IV44", "IV45", "IV46", "IV47", "IV48", "IV49", "IV50", "IV51", "IV52", "IV53", "IV54", "IV55", "IV56", "IV57", "IV58", "IV59", "IV60", "KW1", "KW2", "KW3", "KW4", "KW5", "KW6", "KW7", "KW8", "KW9", "KW10", "KW11", "KW12", "KW13", "KW14", "KW15", "KW16", "KW17", "PH15", "PH16", "PH17", "PH18", "PH19", "PH20", "PH21", "PH22", "PH23", "PH24", "PH25", "PH26", "PH27", "PH28", "PH29", "PH30", "PH31", "PH32", "PH33", "PH34", "PH35", "PH36", "PH37", "PH38", "PH39", "PH40", "PH41", "PH42", "PH43", "PH44", "PH45", "PH46", "PH47", "PH48", "PH49", "PH50", "PA20", "PA21", "PA22", "PA23", "PA24", "PA25", "PA26", "PA27", "PA28", "PA29", "PA30", "PA31", "PA32", "PA33", "PA34", "PA35", "PA36", "PA37", "PA38", "PA39", "PA40", "PA41", "PA42", "PA43", "PA44", "PA45", "PA46", "PA47", "PA48", "PA49", "PA50", "PA51", "PA52", "PA53", "PA54", "PA55", "PA56", "PA57", "PA58", "PA59", "PA60", "PA61", "PA62", "PA63", "PA64", "PA65", "PA66", "PA67", "PA68", "PA69", "PA70", "PA71", "PA72", "PA73", "PA74", "PA75", "PA76", "PA77", "PA78", "KA27", "KA28", "ZE1"
        ];

        const region3Prefixes = [
            "GY", "KW15", "KW16", "KW17", "ZE2", "ZE3", "ZE4", "ZE5", "ZE6", "ZE7", "ZE8", "ZE9"
        ];

        const unsupportedPrefixes = [
            "IM", "JE", "TR2"
        ];

        function isSupportedPostcode(postcode, prefixes) {
            return prefixes.some(prefix => postcode.startsWith(prefix));
        }

        function isNonWorkingDay(date) {
            return date.day() === 0 || date.day() === 6 || bankHolidays.some(holiday => date.isSame(holiday, 'day')) || carrierHolidays.some(holiday => date.isSame(holiday, 'day'));
        }

        function getDeliveryDate(selectedOption) {
            let currentDate = dayjs();
            const cutoffHour = 13;

            if (currentDate.hour() >= cutoffHour) {
                currentDate = currentDate.add(1, 'day');
            }

            let deliveryDate = currentDate;

            while (isNonWorkingDay(deliveryDate)) {
                deliveryDate = deliveryDate.add(1, 'day');
            }

            if (selectedOption.name === 'Saturday') {
                while (deliveryDate.day() !== 6) {
                    deliveryDate = deliveryDate.add(1, 'day');
                }
                return deliveryDate;
            }

            const deliveryDays = parseInt(selectedOption.time.split(' ')[0]);

            for (let i = 0; i < deliveryDays; i++) {
                deliveryDate = deliveryDate.add(1, 'day');
                while (isNonWorkingDay(deliveryDate)) {
                    deliveryDate = deliveryDate.add(1, 'day');
                }
            }

            return deliveryDate;
        }

        function formatDate(date) {
            return dayjs(date).format('ddd, D MMM'); // This formats the date as "28th of May"
        }

        function sortShippingOptions(selectedOptions, deliveryDates) {
            const optionsWithDates = selectedOptions.map((option, index) => {
                return { ...option, deliveryDate: dayjs(deliveryDates[index], 'ddd, D MMM') };
            });

            optionsWithDates.sort((a, b) => a.deliveryDate.diff(b.deliveryDate));

            return optionsWithDates;
        }

        async function updateDeliveryDate(selectedOptions) {
            const deliveryDates = await Promise.all(selectedOptions.map(option => getDeliveryDate(option)));
            const sortedOptions = sortShippingOptions(selectedOptions, deliveryDates);

            const earliestDeliveryDate = sortedOptions[0].deliveryDate.format('ddd, D MMM');
            deliveryDateElement.textContent = earliestDeliveryDate;
        }

        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        async function showShippingOptions() {
            const postcode = postcodeInput.value.trim();
            shippingOptionsElement.innerHTML = ''; // Clear existing services and errors
            showError(''); // Clear previous errors

            const loadingBar = document.createElement('div');
            loadingBar.classList.add('loading-bar');
            loadingBar.innerHTML = '<span></span>';
            shippingOptionsElement.appendChild(loadingBar);

            loadingBar.style.display = 'block';

            const region = determineRegion(postcode);
            let showErrorAfterLoading = false;
            let errorMessage = '';

            if (postcode === '') {
                showErrorAfterLoading = true;
                errorMessage = 'Please enter a valid postcode.';
            } else if (!region) {
                showErrorAfterLoading = true;
                errorMessage = 'Invalid postcode. Please try again.';
            } else if (region === 'unsupported') {
                showErrorAfterLoading = true;
                errorMessage = 'We do not ship to this area.';
            }

            setTimeout(async () => {
                loadingBar.style.display = 'none';

                if (showErrorAfterLoading) {
                    showError(errorMessage);
                    return;
                }

                let selectedOptions = [];
                if (region === 'mainlandUK') {
                    selectedOptions = productWeight < 30 ? shippingOptions.mainlandUK.under30 : shippingOptions.mainlandUK.over30;
                } else if (region === 'region1') {
                    selectedOptions = productWeight < 30 ? shippingOptions.region1.under30 : shippingOptions.region1.over30;
                } else if (region === 'region2') {
                    selectedOptions = productWeight < 30 ? shippingOptions.region2.under30 : shippingOptions.region2.over30;
                } else if (region === 'region3') {
                    selectedOptions = productWeight < 30 ? shippingOptions.region3.under30 : shippingOptions.region3.over30;
                }

                // Calculate delivery dates for all options
                const deliveryDates = await Promise.all(selectedOptions.map(option => getDeliveryDate(option)));

                // Ensure Saturday delivery is handled correctly
                const sortedOptions = sortShippingOptions(selectedOptions, deliveryDates);

                // Display the sorted options in a table
const tableRows = sortedOptions.map((option, index) => {
    let tierClass;
    switch (index) {
        case 0:
            tierClass = 'fast';
            break;
        case 1:
            tierClass = 'mid';
            break;
        case 2:
            tierClass = 'slow';
            break;
        default:
            tierClass = 'special';
    }
    return `
        <tr class="${tierClass}">
            <td>${option.name}</td>
            <td><b>${option.deliveryDate.format('ddd, D MMM')}</b></td>
            <td>${option.price}</td>
        </tr>
    `;
}).join('');


                shippingOptionsElement.innerHTML = `
                    <table class="shipping-table">
                      
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                `;

                await updateDeliveryDate(sortedOptions);
                showError('');
            }, 1000);
        }

        function showError(message) {
            let errorElement = document.querySelector('.error-message');
            if (!errorElement) {
                errorElement = document.createElement('div');
                errorElement.className = 'error-message';
                shippingOptionsElement.appendChild(errorElement);
            }
            errorElement.textContent = message;
            errorElement.style.display = message ? 'block' : 'none';
        }

        postcodeInput.addEventListener('input', debounce(showShippingOptions, 300));

        function toggleShippingOptions() {
            if (shippingOptionsElement.style.maxHeight === '0px' || shippingOptionsElement.style.maxHeight === '') {
                shippingOptionsElement.style.maxHeight = '1000px'; // You can adjust the max height as needed
                shippingOptionsElement.style.opacity = '1';
                shippingOptionsElement.style.display = 'block';
                postcodeCheckElement.style.display = 'flex';
                questionMarkIcon.style.display = 'none';
                closeIcon.style.display = 'block';

                // Call this function to display initial shipping options
                populateInitialShippingOptions();
            } else {
                shippingOptionsElement.style.maxHeight = '0px';
                shippingOptionsElement.style.opacity = '0';
                setTimeout(() => {
                    shippingOptionsElement.style.display = 'none';
                    postcodeCheckElement.style.display = 'none';
                    questionMarkIcon.style.display = 'block';
                    closeIcon.style.display = 'none';
                }, 500); // Match this duration with the animation duration
            }
        }

        async function populateInitialShippingOptions() {
            let selectedOptions = productWeight < 30 ? shippingOptions.mainlandUK.under30 : shippingOptions.mainlandUK.over30;
            const deliveryDates = await Promise.all(selectedOptions.map(option => getDeliveryDate(option)));
            const sortedOptions = sortShippingOptions(selectedOptions, deliveryDates);

            // Display the sorted options in a table
const tableRows = sortedOptions.map((option, index) => {
    let tierClass;
    switch (index) {
        case 0:
            tierClass = 'fast';
            break;
        case 1:
            tierClass = 'mid';
            break;
        case 2:
            tierClass = 'slow';
            break;
        default:
            tierClass = 'special';
    }
    return `
        <tr class="${tierClass}">
            <td>${option.name}</td>
            <td><b>${option.deliveryDate.format('ddd, D MMM')}</b></td>
            <td>${option.price}</td>
        </tr>
    `;
}).join('');

shippingOptionsElement.innerHTML = `
    <table class="shipping-table">
  
        <tbody>
            ${tableRows}
        </tbody>
    </table>
`;

await updateDeliveryDate(sortedOptions);
        }

        deliverySpeedElement.addEventListener('click', function(event) {
            event.preventDefault();
            toggleShippingOptions();
        });

        closePostcodeCheckButton.addEventListener('click', function(event) {
            event.preventDefault();
            toggleShippingOptions();
        });

        function determineRegion(postcode) {
            console.log("Determining region for postcode:", postcode);
            postcode = postcode.toUpperCase().replace(/\s+/g, ''); // Ensure postcode is in uppercase and remove spaces
            if (isSupportedPostcode(postcode, unsupportedPrefixes)) {
                return 'unsupported';
            } else if (isSupportedPostcode(postcode, region1Prefixes)) {
                return 'region1';
            } else if (isSupportedPostcode(postcode, region2Prefixes)) {
                return 'region2';
            } else if (isSupportedPostcode(postcode, region3Prefixes)) {
                return 'region3';
            } else if (isSupportedPostcode(postcode, mainlandUKPrefixes)) {
                return 'mainlandUK';
            } else {
                return null;
            }
        }

        // Populate initial shipping options on page load
        populateInitialShippingOptions();
    }

    initialize();
});


// product warrenty

  // $(document).ready(function () {
  // const $dropdown = $('.csts-custom-dropdown');
  // const $selected = $dropdown.find('.csts-dropdown-selected');
  // const $list = $dropdown.find('ul');
  // const $selectInput = $dropdown.find('select');
  // const $iconDown = $dropdown.find('.icon-down');
  // const $iconUp = $dropdown.find('.icon-up');

  // // 👉 1. Set initial display text
  // const initialValue = $selectInput.val();
  // const initialText = $selectInput.find('option:selected').text();
  // $selected.contents().first()[0].textContent = initialText;
  // console.log('Initial selected value:', initialValue);

  // // 👉 2. Toggle dropdown and icons
  // $selected.on('click', function () {
  //   const isVisible = $list.is(':visible');
  //   $list.toggle();

  //   // Toggle icons
  //   $iconDown.toggle(!isVisible);
  //   $iconUp.toggle(isVisible);
  // });

  // // 👉 3. When item is clicked
  // $list.find('li').on('click', function () {
  //   const value = $(this).data('value');
  //   const text = $(this).text();

  //   $selected.contents().first()[0].textContent = text;
  //   $selectInput.val(value);
  //   $list.hide();

  //   // Reset icons
  //   $iconDown.show();
  //   $iconUp.hide();

  //   console.log('Selected value changed to:', value);
  // });

  // // 👉 4. Close dropdown on outside click
  // $(document).on('click', function (e) {
  //   if (!$(e.target).closest('.csts-custom-dropdown').length) {
  //     $list.hide();
  //     $iconDown.show();
  //     $iconUp.hide();
  //   }
  // });

//     // 👉 5. On button click, get value & send AJAX cart add
// $('button.product-form__submit').on('click', function () {

//   const selectedVal = $selectInput.val(); // "1_year" or "2_year"
//   const variantId = $('.csts-custom-dropdown').attr('prod-id');
  
//   let quantity = (selectedVal === '2_year') ? 2 : 1;

//   if (!variantId) {
//     console.warn('Variant ID not found!');
//     return;
//   }

//   // ✅ Step 1: Add to cart using Shopify AJAX
//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: {
//       id: variantId,
//       quantity: quantity
//     },
//     dataType: 'json',
//     success: function (response) {
//       console.log('Added to cart:', response);

//     },
//     error: function (xhr) {
//       console.error('Add to cart failed:', xhr.responseText);
//     }
//   });
// });
// $('button.button.button--secondary.button--close.drawer__close').on('click',function(){
//   $('cart-drawer#CartDrawer').attr('open',false);
//   $('cart-drawer#CartDrawer').attr('active',false);
//   $('cart-drawer#CartDrawer').attr('hidden',true);
 
// });
  // });


$(document).ready(function () {
  const $dropdown = $('.csts-custom-dropdown');
  const $selected = $dropdown.find('.csts-dropdown-selected');
  const $list = $dropdown.find('ul');
  const $selectInput = $dropdown.find('select');
  const $iconDown = $dropdown.find('.icon-down');
  const $iconUp = $dropdown.find('.icon-up');

  // Set initial text and prod-id
  const initialOption = $selectInput.find('option:selected');
  const initialText = initialOption.text();
  const initialProductId = initialOption.attr('product-id');

  $selected.contents().first()[0].textContent = initialText;
  $dropdown.attr('prod-id', initialProductId);
  console.log('Initial product-id set:', initialProductId);

  // Click to toggle dropdown
  $selected.on('click', function () {
    const isVisible = $list.is(':visible');
    $list.toggle();
    $iconDown.toggle(!isVisible);
    $iconUp.toggle(isVisible);
  });

  // Click on list item
  $list.find('li').on('click', function () {
    const value = $(this).data('value');
    const text = $(this).text();

    $selected.contents().first()[0].textContent = text;
    $selectInput.val(value);
    $list.hide();
    $iconDown.show();
    $iconUp.hide();

    console.log('Selected value changed to:', value);

    // 🔁 Get new product-id and update prod-id on dropdown
    const selectedOption = $selectInput.find(`option[value="${value}"]`);
    const productId = selectedOption.attr('product-id');

    if (productId) {
      $dropdown.attr('prod-id', productId);
      console.log('Updated prod-id to:', productId);
    }
  });

  // Close dropdown on outside click
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.csts-custom-dropdown').length) {
      $list.hide();
      $iconDown.show();
      $iconUp.hide();
    }
  });
});


